<template>
  <div>
    <a class="backBtn" :href="`/#/mission/${missionId}`">
      <img src="/img/back-icon.png" />
    </a>
    <div v-if="isIframe">
      <div class="background-activities"
        :style="`background-image: url('/img/missions/${$route.params.missionId}-Primaria.png')`">
        <div class="sideBar">
          <h1>Recursos</h1>
          <div class="list">
            <div class="button-container" v-if="hasEssentials">
              <button class="active" @click="goToEnglishVersion">
                Recursos en inglés
                <img src="../assets/img/usa.png" class="imgUsa" />
              </button>
            </div>
            <div class="button-container">
              <button class="active" @click="showCurse(1)">Fichas imprimibles</button>
            </div>
            <div class="button-container">
              <button @click="showCurse(2)">Anexos digitales </button>
            </div>
            <!-- <div class="button-container">
              <button @click="showCurse(3)">Cuadernillos complementarios</button>
            </div> -->
            <!-- <div class="button-container">
              <button @click="showCurse(4)">Formato de proyecto</button>
            </div> -->
            <div class="button-container">
              <button @click="showCurse(5)">Rally del conocimiento</button>
            </div>
            <div class="button-container">
              <button @click="showVideo()">Videos</button>
            </div>
            <div class="button-container">
              <button @click="showAudio()">Audios</button>
            </div>
          </div>
        </div>
        <div class="container-resources" v-if="isDownloadable">
          <template v-for="actividad, index in recursos">
            <h2 class="recursos" :key="index" v-if="actividad.grado === missionId && actividad.tipo === isAsignatura">
              {{ actividad.titulo }}
              <br>
              <button @click="downloadIframe(actividad.url)" :class="!actividad.url2 ? 'active' : ''"
                v-if="actividad.tipo === 5">Anual </button>
              <button @click="downloadIframe(actividad.url)" :class="!actividad.url2 ? 'active' : ''" v-else>Libro 1
              </button>
              <button @click="downloadIframe(actividad.url2)" v-if="actividad.url2"
                :class="!actividad.url2 ? 'active' : ''">Libro 2 </button>
              <button @click="downloadIframe(actividad.url3)" v-if="actividad.url3" class="active">Libro 3 </button>
            </h2>
          </template>
        </div>
        <div class="container-videos" v-if="isVideo">
          <div class="tab-trim">
            <button @click="changeTrim(1)" :class="trim === 1 ? 'active' : ''">Trimestre 1 </button>
            <button @click="changeTrim(2)" :class="trim === 2 ? 'active' : ''">Trimestre 2 </button>
            <button @click="changeTrim(3)" :class="trim === 3 ? 'active' : ''">Trimestre 3 </button>
          </div>
          <div class="container-buttons">
            <template v-for="video, index in videos">
              <button :key="index" @click="showIframe(video.url)"
                v-if="video.grade === missionId && video.trim === trim" class="">{{ video.title }}</button>
            </template>
          </div>
        </div>
        <div class="container-audio " v-if="isAudio">
          <template v-for="actividad, index in audios">
            <button :key="index" @click="showIframe(actividad.id)">{{ actividad.title }}</button>
          </template>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="screen-container-book"
        :style="`background-image: url('/img/missions/${$route.params.missionId}-Primaria.png')`">
        <iframe width="835" height="432" :src="`https://player.vimeo.com/video/${iframeId}`" frameborder="0"
          allow="autoplay; encrypted-media" allowfullscreen=""></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import Auth from '../services/Auth';
import NProgress from 'nprogress';
import Button from '../components/Button.vue';

export default {
  components: { Button },
  name: 'resources',
  async created() {
    this.init();
    NProgress.done();
  },
  computed: {
    missionId() {
      return parseInt(this.$route.params.missionId);
    },
    hasEssentials() {
      return this.essentials.some(item =>
        item.includes('Fit For English Essentials')
      );
    },
  },
  data() {
    return {
      isIframe: true,
      isDownloadable: true,
      isVideo: false,
      isAudio: false,
      iframeId: '',
      isAsignatura: 1,
      trim: 3,
      essentials: [],
      recursos: [
        // -------------------------   NIVEL 1 -----------------------------------
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/3Ed/FICHAS_SIN_SOLUCIONARIO/trim1/MP_FICHAS_NIV1_TRIM1_00_BOOK_PLATAFORMA.pdf",
          "url2": "https://storage.googleapis.com/mision-recursos-descargables/Fichas-imprimibles/MP_NV1_LIBRO1_FICHAS_MEDIA-T2.pdf",
          "url3": "https://storage.googleapis.com/mision-recursos-descargables/Fichas-imprimibles/MP_NV1_LIBRO1_FICHAS_MEDIA-T3.pdf",
          "titulo": "Fichas imprimibles",
          "tipo": 1,
          "grado": 1,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Anexos-digitales/trim1/MP_NIV1_TRIM1_ANEXO.pdf",
          "url2": "https://storage.googleapis.com/mision-recursos-descargables/Anexos-digitales/MP_NV1_LIBRO1_ANEXOS-MEDIA-T2.pdf",
          "url3": "https://storage.googleapis.com/mision-recursos-descargables/Anexos-digitales/MP_NV1_LIBRO1_ANEXOS-MEDIA-T3.pdf",
          "titulo": "Anexos digitales",
          "tipo": 2,
          "grado": 1,
        },
        // {
        //     "url": "https://storage.googleapis.com/mision-recursos-descargables/ed2/CUADERNILLO_CIVICA_ETICA/ALUMNOS/MP_2ED_CIVICA_ETICA_ALUMNO_NV1_TRIM1_MEDIA_PLATAFORMA.pdf",
        //     "url2": "https://storage.googleapis.com/mision-recursos-descargables/Cuadernillos-complementarios/MP_CUADERNILLO_FCYE_NV1_T2.pdf",
        //     "titulo": "Cuadernillo de Formación Cívica y Etica",
        //     "tipo": 3,
        //     "grado": 1,
        // },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/ed2/TRAZOS_LETRAS/MP_2ED_CUADERNILLO_ESCRITURA_E1_TRIM1_MEDIA_PLATAFORMA.pdf",
          "titulo": "Cuadernillo de trazo",
          "tipo": 3,
          "grado": 1,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/3Ed/CUADERNILLO_MATEMATICAS/MP_3ED_NV1_RECORTABLES_COMPLEMENTARIOS_PLATAFORMA.pdf",
          "titulo": "Cuadernillo prácticas de Matemáticas",
          "tipo": 3,
          "grado": 1,
        },

        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/ed2/CUADERNILLO_VALORES/MP_NV1_CUADERNILLO_VALORES_ANUAL_PLATAFORMA.pdf",
          "titulo": "Cuadernillo de Valores",
          "tipo": 3,
          "grado": 1,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Formato-de-Proyecto/MP_ETAPA1_PROYECTOS_plataforma.pdf",
          "titulo": "Formato de Proyecto",
          "tipo": 4,
          "grado": 1,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Rally-del-conocimiento/MP_NV1_LIBRO1_RALLY_DEL_CONOCIMIENTO_PLATAFORMA.pdf",
          "titulo": "Rally del conocimiento",
          "tipo": 5,
          "grado": 1,
        },
        // -------------------------   NIVEL 2 -----------------------------------
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/3Ed/FICHAS_SIN_SOLUCIONARIO/trim1/MP_FICHAS_NIV2_TRIM1_00_BOOK_PLATAFORMA.pdf",
          "url2": "https://storage.googleapis.com/mision-recursos-descargables/ed2/FICHAS_SIN_SOLUCIONARIO/MP_FICHAS_NV2_TRIM2_00_BOOK_PLATAFORMA.pdf",
          "url3": "https://storage.googleapis.com/mision-recursos-descargables/Fichas-imprimibles/MP_NV2_LIBRO1_FICHAS_MEDIA-T3.pdf",
          "titulo": "Fichas imprimibles",
          "tipo": 1,
          "grado": 2,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Anexos-digitales/MP_NV2_LIBRO1_ANEXOS-MEDIA.pdf",
          "url2": "https://storage.googleapis.com/mision-recursos-descargables/Anexos-digitales/MP_NV2_LIBRO1_ANEXOS-MEDIA-T2.pdf",
          "url3": "https://storage.googleapis.com/mision-recursos-descargables/Anexos-digitales/MP_NV2_LIBRO1_ANEXOS-MEDIA-T3.pdf",
          "titulo": "Anexos digitales",
          "tipo": 2,
          "grado": 2,
        },
        // {
        //     "url": "https://storage.googleapis.com/mision-recursos-descargables/ed2/CUADERNILLO_CIVICA_ETICA/ALUMNOS/MP_2ED_CIVICA_ETICA_ALUMNO_NV2_TRIM1_MEDIA_PLATAFORMA.pdf",
        //     "url2": "https://storage.googleapis.com/mision-recursos-descargables/Cuadernillos-complementarios/MP_CUADERNILLO_FCYE_NV2_T2.pdf",
        //     "titulo": "Cuadernillo de Formación Cívica y Etica",
        //     "tipo": 3,
        //     "grado": 2,
        // },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/3Ed/CUADERNILLO_MATEMATICAS/MP_3ED_NV2_RECORTABLES_COMPLEMENTARIOS_PLATAFORMA.pdf",
          "titulo": "Cuadernillo prácticas de Matemáticas",
          "tipo": 3,
          "grado": 2,
        },

        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Cuadernillo-de-Valores/MP_NV1_VALORES_00_BOOK_plataforma.pdf",
          "titulo": "Cuadernillo de Valores",
          "tipo": 3,
          "grado": 2,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Formato-de-Proyecto/MP_ETAPA1_PROYECTOS_plataforma.pdf",
          "titulo": "Formato de Proyecto",
          "tipo": 4,
          "grado": 2,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Rally-del-conocimiento/MP_NV2_TRIM1_RALLY_DEL_CONOCIMIENTO_PLATAFORMA.pdf",
          "titulo": "Rally del conocimiento",
          "tipo": 5,
          "grado": 2,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Lista_de_cotejo_Habilidades/Lista%20de%20cotejo_Habilidades.xlsx",
          "titulo": "Lista de cotejo de habilidades",
          "grado": 2,
        },
        // -------------------------   NIVEL 3 -----------------------------------
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/3Ed/FICHAS_SIN_SOLUCIONARIO/trim1/MP_FICHAS_NIV3_TRIM1_00_BOOK_PLATAFORMA.pdf",
          "url2": "https://storage.googleapis.com/mision-recursos-descargables/Fichas-imprimibles/MP_NV3_LIBRO1_FICHAS_MEDIA-T2.pdf",
          "url3": "https://storage.googleapis.com/mision-recursos-descargables/Fichas-imprimibles/MP_NV3_LIBRO1_FICHAS_MEDIA-T3.pdf",
          "titulo": "Fichas imprimibles",
          "tipo": 1,
          "grado": 3,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Anexos-digitales/trim1/MP_NIV3_TRIM1_ANEXO.pdf",
          "url2": "https://storage.googleapis.com/mision-recursos-descargables/Anexos-digitales/MP_NV3_LIBRO1_ANEXOS-MEDIA-T2.pdf",
          "url3": "https://storage.googleapis.com/mision-recursos-descargables/Anexos-digitales/MP_NV3_LIBRO1_ANEXOS-MEDIA-T3.pdf",
          "titulo": "Anexos digitales",
          "tipo": 2,
          "grado": 3,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Cuadernillos-complementarios/MP_Cuadernillo%20de%20Escritura%20Etapa%202_Plataforma.pdf",
          "titulo": "Cuadernillo de trazo",
          "tipo": 3,
          "grado": 3,
        },

        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Formato-de-Proyecto/MP_ETAPA1_PROYECTOS_plataforma.pdf",
          "titulo": "Formato de Proyecto",
          "tipo": 4,
          "grado": 3,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Rally-del-conocimiento/MP_NV3_TRIM1_RALLY_DEL_CONOCIMIENTO_PLATAFORMA.pdf",
          "titulo": "Rally del conocimiento",
          "tipo": 5,
          "grado": 3,
        },
        // -------------------------   NIVEL 4 -----------------------------------
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/3Ed/FICHAS_SIN_SOLUCIONARIO/trim1/MP_FICHAS_NIV4_TRIM1_00_BOOK_PLATAFORMA.pdf",
          "url2": "https://storage.googleapis.com/mision-recursos-descargables/Fichas-imprimibles/MP_NV4_LIBRO1_FICHAS_MEDIA-T2.pdf",
          "url3": "https://storage.googleapis.com/mision-recursos-descargables/Fichas-imprimibles/MP_NV4_LIBRO1_FICHAS_MEDIA-T3.pdf",
          "titulo": "Fichas imprimibles",
          "tipo": 1,
          "grado": 4,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Anexos-digitales/trim1/MP_NIV4_TRIM1_ANEXO.pdf",
          "url2": "https://storage.googleapis.com/mision-recursos-descargables/Anexos-digitales/MP_NV4_LIBRO1_ANEXOS-MEDIA-T2.pdf",
          "url3": "https://storage.googleapis.com/mision-recursos-descargables/Anexos-digitales/MP_NV4_LIBRO1_ANEXOS-MEDIA-T3.pdf",
          "titulo": "Anexos digitales",
          "tipo": 2,
          "grado": 4,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Cuadernillo-de-Valores/MP_NV4_CUADERNILLO_VALORES_ANUAL_PLATAFORMA.pdf",
          "titulo": "Cuadernillo de Valores",
          "tipo": 3,
          "grado": 4,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Formato-de-Proyecto/MP_NV4_PROYECTOS_PLATAFORMA.pdf",
          "titulo": "Formato de Proyecto",
          "tipo": 4,
          "grado": 4,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Rally-del-conocimiento/MP_NV4_LIBRO1_RALLY_DEL_CONOCIMIENTO_PLATAFORMA.pdf",
          "titulo": "Rally del conocimiento",
          "tipo": 5,
          "grado": 4,
        },
        // -------------------------   NIVEL 5 -----------------------------------
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/3Ed/FICHAS_SIN_SOLUCIONARIO/trim1/MP_FICHAS_NIV5_TRIM1_00_BOOK_PLATAFORMA.pdf",
          "url2": "https://storage.googleapis.com/mision-recursos-descargables/Fichas-imprimibles/MP_NV5_LIBRO1_FICHAS_MEDIA-T2.pdf",
          "url3": "https://storage.googleapis.com/mision-recursos-descargables/Fichas-imprimibles/MP_NV5_LIBRO1_FICHAS_MEDIA-T3.pdf",
          "titulo": "Fichas imprimibles",
          "tipo": 1,
          "grado": 5,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Anexos-digitales/trim1/MP_NIV5_TRIM1_ANEXO.pdf",
          "url2": "https://storage.googleapis.com/mision-recursos-descargables/Anexos-digitales/MP_NV5_LIBRO1_ANEXOS-MEDIA-T2.pdf",
          "url3": "https://storage.googleapis.com/mision-recursos-descargables/Anexos-digitales/MP_NV5_LIBRO1_ANEXOS-MEDIA-T3.pdf",
          "titulo": "Anexos digitales",
          "tipo": 2,
          "grado": 5,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Cuadernillo-de-Valores/MP_NV5_CUADERNILLO_VALORES_ANUAL_PLATAFORMA.pdf",
          "titulo": "Cuadernillo de Valores",
          "tipo": 3,
          "grado": 5,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Formato-de-Proyecto/MP_NV5_PROYECTOS_PLATAFORMA.pdf",
          "titulo": "Formato de Proyecto",
          "tipo": 4,
          "grado": 5,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Rally-del-conocimiento/MP_NV5_LIBRO1_RALLY_DEL_CONOCIMIENTO_PLATAFORMA.pdf",
          "titulo": "Rally del conocimiento",
          "tipo": 5,
          "grado": 5,
        },
        // -------------------------   NIVEL 6 -----------------------------------

        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/3Ed/FICHAS_SIN_SOLUCIONARIO/trim1/MP_FICHAS_NIV6_TRIM1_00_BOOK_PLATAFORMA.pdf",
          "url2": "https://storage.googleapis.com/mision-recursos-descargables/Fichas-imprimibles/MP_NV6_LIBRO1_FICHAS_MEDIA-T2.pdf",
          "url3": "https://storage.googleapis.com/mision-recursos-descargables/Fichas-imprimibles/MP_NV6_LIBRO1_FICHAS_MEDIA-T3.pdf",
          "titulo": "Fichas imprimibles",
          "tipo": 1,
          "grado": 6,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Anexos-digitales/trim1/MP_NIV6_TRIM1_ANEXO.pdf",
          "url2": "https://storage.googleapis.com/mision-recursos-descargables/Anexos-digitales/MP_NV6_LIBRO1_ANEXOS-MEDIA-T2.pdf",
          "url3": "https://storage.googleapis.com/mision-recursos-descargables/Anexos-digitales/MP_NV6_LIBRO1_ANEXOS-MEDIA-T3.pdf",
          "titulo": "Anexos digitales",
          "tipo": 2,
          "grado": 6,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Cuadernillos-complementarios/MP_NV6_CUADERNILLO_MATEMATICAS_PLATAFORMA.pdf",
          "titulo": "Cuadernillo prácticas de Matemáticas",
          "tipo": 3,
          "grado": 6,
        },

        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Cuadernillo-de-Valores/PM_NV6_1ED_VALORES_ANUAL_FINAL.pdf",
          "titulo": "Cuadernillo de Valores",
          "tipo": 3,
          "grado": 6,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Formato-de-Proyecto/MP_NV6_PROYECTOS_PLATAFORMA.pdf",
          "titulo": "Formato de Proyecto",
          "tipo": 4,
          "grado": 6,
        },
        {
          "url": "https://storage.googleapis.com/mision-recursos-descargables/Rally-del-conocimiento/MP_NV6_LIBRO1_RALLY_DEL_CONOCIMIENTO_PLATAFORMA.pdf",
          "titulo": "Rally del conocimiento",
          "tipo": 5,
          "grado": 6,
        },

      ],
      videos: [
        {
          "grade": 1,
          "title": "Identidad",
          "url": "549414035",
          "trim": 1
        },
        {
          "grade": 1,
          "title": "El Rekenrek",
          "url": "549413346",
          "trim": 1
        },
        {
          "grade": 1,
          "title": "Miembros y parentescos de una familia",
          "url": "549414181",
          "trim": 1
        },
        {
          "grade": 1,
          "title": "Técnica de cepillado de dientes",
          "url": "549414228",
          "trim": 1
        },
        {
          "grade": 1,
          "title": "Día y noche",
          "url": "549413474",
          "trim": 1
        },
        {
          "grade": 1,
          "title": "La comunicación escrita",
          "url": "549414097",
          "trim": 1
        },
        {
          "grade": 1,
          "title": "México, el país de las maravillas naturales",
          "url": "549413887",
          "trim": 1
        },
        {
          "grade": 1,
          "title": "Aprendo a decidir",
          "url": "549413780",
          "trim": 1
        },
        {
          "grade": 1,
          "title": "La vida es un ciclo",
          "url": "549413584",
          "trim": 1
        },
        {
          "grade": 1,
          "title": "Retículas",
          "url": "649559778",
          "trim": 2,
        },
        {
          "grade": 1,
          "title": "Empatía",
          "url": "652500899",
          "trim": 2,
        },
        {
          "grade": 1,
          "title": "Mi árbol genealógico",
          "url": "649559623",
          "trim": 2,
        },
        {
          "grade": 1,
          "title": "Nuestro lugar de pertenencia",
          "url": "649559689",
          "trim": 2,
        },
        {
          "grade": 1,
          "title": "Tabla de 100",
          "url": "649559810",
          "trim": 2,
        },
        // { 
        //   "grade": 1,
        //   "title": "Empatía",
        //   "url": "1205",
        //   "trim": 2,
        // },
        {
          "grade": 1,
          "title": "Los juguetes de ayer y hoy",
          "url": "649559494",
          "trim": 2,
        },
        {
          "grade": 1,
          "title": "¿Cómo llega la electricidad a nuestras casas?",
          "url": "649559267",
          "trim": 2,
        },
        {
          "grade": 1,
          "title": "Derechos y obligaciones",
          "url": "649559375",
          "trim": 2,
        },
        {
          "grade": 1,
          "title": "Tipos de casas",
          "url": "649559857",
          "trim": 2,
        },
        {
          "grade": 2,
          "title": "Sustantivos propios y comunes",
          "url": "549415405",
          "trim": 1,
        },
        {
          "grade": 2,
          "title": "He cambiado",
          "url": "549415258",
          "trim": 1,
        },
        {
          "grade": 2,
          "title": "Hoja de cambios ",
          "url": "549416345",
          "trim": 1,
        },
        {
          "grade": 2,
          "title": "El cuidado de nuestros cuerpos",
          "url": "549415657",
          "trim": 1,
        },
        {
          "grade": 2,
          "title": "La higiene y los alimentos",
          "url": "549415514",
          "trim": 1,
        },
        {
          "grade": 2,
          "title": "Mirar el mundo con otros sentidos",
          "url": "549415743",
          "trim": 1,
        },
        {
          "grade": 2,
          "title": "Mi país en el mundo",
          "url": "549415874",
          "trim": 1,
        },
        {
          "grade": 2,
          "title": "¿Qué hay en el espacio?",
          "url": "549415972",
          "trim": 1,
        },
        {
          "grade": 2,
          "title": "Relieves",
          "url": "549416105",
          "trim": 1,
        },
        {
          "grade": 2,
          "title": "Medición del tiempo",
          "url": "549416237",
          "trim": 1,
        },
        {
          "grade": 2,
          "title": "Sumas, poner",
          "url": "549416237",
          "trim": 1,
        },
        {
          "grade": 2,
          "title": "Los estados del agua y la temperatura",
          "url": "649643020",
          "trim": 2,
        },
        {
          "grade": 2,
          "title": "Cambios en el entorno",
          "url": "649643078",
          "trim": 2,
        },
        {
          "grade": 2,
          "title": "Comunidades rurales y urbanas",
          "url": "649642558",
          "trim": 2,
        },
        {
          "grade": 2,
          "title": "Importancia de las plantas",
          "url": "649642644",
          "trim": 2,
        },
        {
          "grade": 2,
          "title": "Diversidad cultural",
          "url": "649642745",
          "trim": 2,
        },
        {
          "grade": 2,
          "title": "Sumas largas",
          "url": "649643012",
          "trim": 2,
        },
        {
          "grade": 2,
          "title": "La migración",
          "url": "649642836",
          "trim": 2,
        },
        {
          "grade": 2,
          "title": "La inclusión en el medioambiente escolar",
          "url": "649642935",
          "trim": 2,
        },
        {
          "grade": 3,
          "title": "La alimentación",
          "url": "549418452",
          "trim": 1,
        },
        {
          "grade": 3,
          "title": "Los componentes naturales de mi entidad",
          "url": "549417958",
          "trim": 1,
        },
        {
          "grade": 3,
          "title": "Inegi",
          "url": "549417633",
          "trim": 1,
        },
        {
          "grade": 3,
          "title": "Sistema nervioso",
          "url": "549417836",
          "trim": 1,
        },
        {
          "grade": 3,
          "title": "Tolerancia a diferencias",
          "url": "549419036",
          "trim": 1,
        },
        {
          "grade": 3,
          "title": "Me cuido y evito situaciones de riesgo",
          "url": "549418293",
          "trim": 1,
        },
        {
          "grade": 3,
          "title": "Volcán Paricutín",
          "url": "549418872",
          "trim": 1,
        },
        {
          "grade": 3,
          "title": "Plan familiar de protección civil",
          "url": "549418526",
          "trim": 1,
        },
        {
          "grade": 3,
          "title": "Cómo respiran los animales",
          "url": "549417469",
          "trim": 1,
        },
        {
          "grade": 3,
          "title": "Compartimos características físicas",
          "url": "549418160",
          "trim": 1,
        },
        {
          "grade": 3,
          "title": "A nuestro servicio",
          "url": "549417267",
          "trim": 1,
        },
        {
          "grade": 3,
          "title": "Multiplicaciones por 10, 100 y 1000",
          "url": "549418781",
          "trim": 1,
        },
        {
          "grade": 3,
          "title": "Multiplicación",
          "url": "549418235",
          "trim": 1,
        },
        {
          "grade": 3,
          "title": "La contaminación del aire y el agua",
          "url": "650060876",
          "trim": 2,
        },
        {
          "grade": 3,
          "title": "La responsabilidad",
          "url": "650060606",
          "trim": 2,
        },
        {
          "grade": 3,
          "title": "Algoritmo de la multiplicación",
          "url": "652505271",
          "trim": 2,
        },
        {
          "grade": 3,
          "title": "Masa y volumen",
          "url": "650060726",
          "trim": 2,
        },
        {
          "grade": 3,
          "title": "Texto de divulgación científica",
          "url": "650060760",
          "trim": 2,
        },
        {
          "grade": 3,
          "title": "Restas con transformación",
          "url": "650060704",
          "trim": 2,
        },
        {
          "grade": 4,
          "url": "549421903",
          "title": "¿Nos alimentamos bien?",
          "trim": 1,
        },
        {
          "grade": 4,
          "url": "549421775",
          "title": "Poblamiento de América",
          "trim": 1,
        },
        {
          "grade": 4,
          "url": "549422146",
          "title": "Tres regiones diferentes",
          "trim": 1,
        },
        {
          "grade": 4,
          "url": "549421031",
          "title": "Derechos de los niños",
          "trim": 1,
        },
        {
          "grade": 4,
          "url": "549422026",
          "title": "Fracciones con regletas",
          "trim": 1,
        },
        {
          "grade": 4,
          "url": "549420875",
          "title": "¿Cómo y para qué respiramos?",
          "trim": 1,
        },
        {
          "grade": 4,
          "url": "549421655",
          "title": "Extensión territorial de México",
          "trim": 1,
        },
        {
          "grade": 4,
          "url": "549421393",
          "title": "El maíz nuestro",
          "trim": 1,
        },
        {
          "grade": 4,
          "url": "549420714",
          "title": "Clasificación del reino animal",
          "trim": 1,
        },
        {
          "grade": 4,
          "url": "549422352",
          "title": "La recta numérica abierta",
          "trim": 1,
        },
        {
          "grade": 4,
          "url": "549421235",
          "title": "Hongos y bacterias",
          "trim": 1,
        },
        {
          "grade": 4,
          "url": "549421497",
          "title": "Los climas",
          "trim": 1,
        },
        {
          "grade": 4,
          "url": "549422118",
          "title": "Decimales",
          "trim": 1,
        },
        {
          "grade": 4,
          "title": "La libertad de expresión y la no discriminación",
          "url": "650065933",
          "trim": 2,
        },
        {
          "grade": 4,
          "title": "El descubrimiento de América",
          "url": "650065605",
          "trim": 2,
        },
        {
          "grade": 4,
          "title": "Rutas marítimas",
          "url": "650066096",
          "trim": 2,
        },
        {
          "grade": 4,
          "title": "Método de conservación de los alimentos",
          "url": "650065971",
          "trim": 2,
        },
        {
          "grade": 4,
          "title": "Equidad de género",
          "url": "650065840",
          "trim": 2,
        },
        {
          "grade": 4,
          "title": "Estrategia de multiplicación",
          "url": "650065894",
          "trim": 2,
        },
        {
          "grade": 4,
          "title": "Recursos gráficos de la publicidad",
          "url": "650066041",
          "trim": 2,
        },
        {
          "grade": 4,
          "title": "Tolerancia",
          "url": "650065527",
          "trim": 2,
        },
        {
          "grade": 4,
          "title": "Arreglos rectangulares",
          "url": "650065783",
          "trim": 2,
        },
        {
          "grade": 4,
          "title": "Actividades económicas de México",
          "url": "650065733",
          "trim": 2,
        },
        {
          "grade": 5,
          "url": 587933583,
          "title": "Desplazamiento de los continentes",
          "trim": 1,
        },
        {
          "grade": 5,
          "url": 587933175,
          "title": "La fraternidad",
          "trim": 1,
        },
        {
          "grade": 5,
          "url": 587933477,
          "title": "¿Por qué debo cuidarme?",
          "trim": 1,
        },
        {
          "grade": 5,
          "url": 587933244,
          "title": "Ángulos",
          "trim": 1,
        },
        {
          "grade": 5,
          "url": 587933728,
          "title": "Los intereses extranjeros",
          "trim": 1,
        },
        {
          "grade": 5,
          "url": 587933833,
          "title": "Los continentes y sus paisajes",
          "trim": 1,
        },
        {
          "grade": 5,
          "url": 587933304,
          "title": "Las leyes de Reforma",
          "trim": 1,
        },
        {
          "grade": 5,
          "url": 587933207,
          "title": "Fracción de un todo",
          "trim": 1,
        },
        {
          "grade": 5,
          "url": 587933655,
          "title": "¿Cuestión de raza o de dominio propio?",
          "trim": 1,
        },
        {
          "grade": 5,
          "url": 587933361,
          "title": "Recursos naturales",
          "trim": 1,
        },
        {
          "grade": 5,
          "title": "Biomas",
          "url": "650067017",
          "trim": 2,
        },
        {
          "grade": 5,
          "title": "Dictadura de Porfirio Díaz",
          "url": "650067103",
          "trim": 2,
        },
        {
          "grade": 5,
          "title": "Procesos de transferencia de calor",
          "url": "650067333",
          "trim": 2,
        },
        {
          "grade": 5,
          "title": "La gravedad",
          "url": "650067179",
          "trim": 2,
        },
        {
          "grade": 5,
          "title": "Respeto a la diversidad cultural",
          "url": "650067371",
          "trim": 2,
        },
        {
          "grade": 5,
          "title": "Área de cuadriláteros y triángulos",
          "url": "650066985",
          "trim": 2,
        },
        {
          "grade": 5,
          "title": "La vida en las haciendas",
          "url": "650067244",
          "trim": 2,
        },
        {
          "grade": 5,
          "title": "El sonido y su propagación",
          "url": "650067134",
          "trim": 2,
        },
        {
          "grade": 6,
          "url": 587938531,
          "title": "Línea del tiempo: Prehistoria",
          "trim": 1,
        },
        {
          "grade": 6,
          "url": 587939015,
          "title": "Fracciones ",
          "trim": 1,
        },
        {
          "grade": 6,
          "url": 587938441,
          "title": "El valor de vivir",
          "trim": 1,
        },
        {
          "grade": 6,
          "url": 587939028,
          "title": "Sistemas del cuerpo",
          "trim": 1,
        },
        {
          "grade": 6,
          "url": 587938945,
          "title": "Soy responsable de mi persona",
          "trim": 1,
        },
        {
          "grade": 6,
          "url": 587938864,
          "title": "Las primeras ciudades",
          "trim": 1,
        },
        {
          "grade": 6,
          "url": 587938781,
          "title": "El GPS",
          "trim": 1,
        },
        {
          "grade": 6,
          "url": 587939094,
          "title": "Fósiles",
          "trim": 1,
        },
        {
          "grade": 6,
          "url": 587938702,
          "title": "Sociedad, naturaleza y ser humano",
          "trim": 1,
        },
        {
          "grade": 6,
          "url": 587938651,
          "title": "Disciplina",
          "trim": 1,
        },
        {
          "grade": 6,
          "title": "Corrientes marinas",
          "url": "650329045",
          "trim": 2,
        },
        {
          "grade": 6,
          "title": "Porcentajes con tablas",
          "url": "650329441",
          "trim": 2,
        },
        {
          "grade": 6,
          "title": "Presidente José Mujica",
          "url": "650329273",
          "trim": 2,
        },
        {
          "grade": 6,
          "title": "Legados del mundo antiguo",
          "url": "650329207",
          "trim": 2,
        },
        {
          "grade": 6,
          "title": "El relato histórico",
          "url": "650328636",
          "trim": 2,
        },
        {
          "grade": 6,
          "title": "Historia de las cosas",
          "url": "650328694",
          "trim": 2,
        },
        {
          "grade": 6,
          "title": "Múltiplos y divisores en la tabla de 100",
          "url": "650329008",
          "trim": 2,
        },
        {
          "grade": 6,
          "title": "Repeto y valoración de la diversidad",
          "url": "650329479",
          "trim": 2,
        },
        {
          "grade": 6,
          "title": "Los incas",
          "url": "650328748",
          "trim": 2,
        },
        {
          "grade": 6,
          "title": "Constancia",
          "url": "650328537",
          "trim": 2,
        },
        {
          "grade": 6,
          "title": "Máquinas simples en la actualidad",
          "url": "650328900",
          "trim": 2,
        },
        {
          grade: 1,
          trim: 3,
          url: '649594068',
          subject: 'Matemáticas',
          pageNumber: 180,
          title: 'Combinaciones'
        },
        {
          grade: 1,
          trim: 3,
          url: '649594141',
          subject: 'Conocimiento del medio',
          pageNumber: 116,
          title: 'El Buen Uso Del Agua'
        },
        {
          grade: 1,
          trim: 3,
          url: '649594225',
          subject: 'Expresión escrita',
          pageNumber: 172,
          title: 'El Cuento'
        },
        {
          grade: 1,
          trim: 3,
          url: '649594296',
          subject: 'Conocimiento del medio',
          pageNumber: 56,
          title: 'La energía del sol'
        },
        {
          grade: 1,
          trim: 3,
          url: '649594414',
          subject: 'Conocimiento del medio',
          pageNumber: 136,
          title: 'Las Nubes'
        },
        {
          grade: 1,
          trim: 3,
          url: '649594489',
          subject: 'Conocimiento del medio',
          pageNumber: 76,
          title: 'Los objetos y sus materiales'
        },
        {
          grade: 1,
          trim: 3,
          url: '649594551',
          subject: 'Conocimiento del medio',
          pageNumber: 36,
          title: 'Señales de tránsito'
        },
        {
          grade: 1,
          trim: 3,
          url: '649594625',
          subject: 'Matemáticas',
          pageNumber: 63,
          title: 'Sumas con números amigables'
        },
        {
          grade: 1,
          trim: 3,
          url: '649594684',
          subject: 'Expresión escrita',
          pageNumber: 152,
          title: 'El personaje'
        },
        {
          grade: 2,
          trim: 3,
          url: '649982661',
          subject: 'Conocimiento del medio',
          pageNumber: 16,
          title: 'Recursos naturales'
        },
        {
          grade: 2,
          trim: 3,
          url: '649982962',
          subject: 'Conocimiento del medio',
          pageNumber: 36,
          title: 'Productos del campo y la industria'
        },
        {
          grade: 2,
          trim: 3,
          url: '649983067',
          subject: 'Conocimiento del medio',
          pageNumber: 56,
          title: 'El comercio y el transporte'
        },
        {
          grade: 2,
          trim: 3,
          url: '649983208',
          subject: 'Matemáticas',
          pageNumber: 63,
          title: 'Restas con cambios'
        },
        {
          grade: 2,
          trim: 3,
          url: '649983067',
          subject: 'Conocimiento del medio',
          pageNumber: 76,
          title: 'Los servicios públicos de mi comunidad'
        },
        {
          grade: 2,
          trim: 3,
          url: '649983208',
          subject: 'Ortografía',
          pageNumber: 90,
          title: 'Las reglas de acentuación'
        },
        {
          grade: 2,
          trim: 3,
          url: '649983264',
          subject: 'Habilidades Generales',
          pageNumber: 111,
          title: 'El sustantivo'
        },
        {
          grade: 2,
          trim: 3,
          url: '649983324',
          subject: 'Conocimiento del medio',
          pageNumber: 136,
          title: 'Efectos de la radiación solar'
        },
        {
          grade: 2,
          trim: 3,
          url: '649983486',
          subject: 'Conocimiento del medio',
          pageNumber: 156,
          title: 'Movimiento y trayectoria de los objetos'
        },
        {
          grade: 2,
          trim: 3,
          url: '649983585',
          subject: 'Conocimiento del medio',
          pageNumber: 176,
          title: 'Prevención de desastres'
        },
        {
          grade: 2,
          trim: 3,
          url: '649983932',
          subject: 'Matemáticas',
          pageNumber: 181,
          title: 'Estrategia de división'
        },
        {
          grade: 3,
          trim: 3,
          url: '651191669',
          subject: 'Ciencias naturales',
          pageNumber: '15,75',
          title: 'Sonido',
        },
        {
          grade: 3,
          trim: 3,
          url: '651191745',
          subject: 'Matemáticas',
          pageNumber: 82,
          title: 'Sumas repetidas',
        },
        {
          grade: 3,
          trim: 3,
          url: '651191811',
          subject: 'Matemáticas',
          pageNumber: 124,
          title: 'Algoritmo de la división',
        },
        {
          grade: 3,
          trim: 3,
          url: '651191844',
          subject: 'Mi localidad',
          pageNumber: 136,
          title: 'Conciencia ambiental',
        },
        {
          grade: 3,
          trim: 3,
          url: '651191919',
          subject: 'Ciencias naturales',
          pageNumber: 154,
          title: 'Organización ecologista',
        },
        {
          grade: 3,
          trim: 3,
          url: '651191977',
          subject: 'Mi localidad',
          pageNumber: 116,
          title: 'Patrimonio cultural en México',
        },
        {
          grade: 3,
          trim: 3,
          url: '651192137',
          subject: 'Ciencias naturales',
          pageNumber: 135,
          title: 'Plantas medicinales y para qué sirven',
        },
        {
          grade: 4,
          trim: 3,
          url: '651216734',
          subject: 'Expresión Oral',
          pageNumber: 13,
          title: 'La narración'
        },
        {
          grade: 4,
          trim: 3,
          url: '651216638',
          subject: 'Ortografía',
          pageNumber: 32,
          title: 'El diálogo'
        },
        {
          grade: 4,
          trim: 3,
          url: '651216267',
          subject: 'Historia',
          pageNumber: 60,
          title: 'Causas del descontento social'
        },
        {
          grade: 4,
          trim: 3,
          url: '651216827',
          subject: 'Ciencias naturales',
          pageNumber: 103,
          title: 'Los eclipses'
        },
        {
          grade: 4,
          trim: 3,
          url: '651216331',
          subject: 'Matemáticas',
          pageNumber: 113,
          title: 'Complementos'
        },
        {
          grade: 4,
          trim: 3,
          url: '651216540',
          subject: 'Ciencias Naturales',
          pageNumber: 124,
          title: 'Creencias de la antigüedad'
        },
        {
          grade: 4,
          trim: 3,
          url: '651216602',
          subject: 'Expresión escrita',
          pageNumber: 166,
          title: 'El debate'
        },
        {
          grade: 4,
          trim: 3,
          url: '651216421',
          subject: 'Ciencias naturales',
          pageNumber: 190,
          title: 'Condiciones para que exista la vida'
        },
        {
          grade: 5,
          trim: 3,
          url: '651222319',
          subject: 'Ciencias Naturales',
          pageNumber: 103,
          title: 'Adicciones en las redes sociales'
        },
        {
          grade: 5,
          trim: 3,
          url: '651222473',
          subject: 'Ciencias Naturales',
          pageNumber: 59,
          title: '¿Cómo llega la electricidad a nuestras casas?'
        },
        {
          grade: 5,
          trim: 3,
          url: '651222559',
          subject: 'Matemáticas',
          pageNumber: 91,
          title: 'Conversiones en la hoja de cambios'
        },
        {
          grade: 5,
          trim: 3,
          url: '651222604',
          subject: 'Historia',
          pageNumber: 148,
          title: 'Desigualdad y protestas sociales'
        },
        {
          grade: 5,
          trim: 3,
          url: '651222679',
          subject: 'Ciencias Naturales',
          pageNumber: 80,
          title: 'Diferencias entre calor y temperatura'
        },
        {
          grade: 5,
          trim: 3,
          url: '651222759',
          subject: 'Formación cívica',
          pageNumber: 172,
          title: 'La democracia como forma de gobierno'
        },
        {
          grade: 5,
          trim: 3,
          url: '651222873',
          subject: 'Ciencias Naturales',
          pageNumber: 37,
          title: 'Las frutas y la electricidad'
        },
        {
          grade: 5,
          trim: 3,
          url: '651222947',
          subject: 'Ciencias Naturales',
          pageNumber: 124,
          title: 'Los planetas'
        },
        {
          grade: 5,
          trim: 3,
          url: '651223041',
          subject: 'Formación cívica',
          pageNumber: 84,
          title: 'Los símbolos patrios'
        },
        {
          grade: 5,
          trim: 3,
          url: '651223186',
          subject: 'Matemáticas',
          pageNumber: 133,
          title: 'Multiplicaciones mayas'
        },
        {
          grade: 5,
          trim: 3,
          url: '651223239',
          subject: 'Matemáticas',
          pageNumber: 201,
          title: 'Porcentajes'
        },
        {
          grade: 5,
          trim: 3,
          url: '651223316',
          subject: 'Formación cívica',
          pageNumber: 62,
          title: 'Servicios y pago de impuestos'
        },
        {
          grade: 5,
          trim: 3,
          url: '683380774',
          subject: 'Formación cívica',
          pageNumber: 18,
          title: 'Los derechos humanos'
        },
        {
          grade: 6,
          trim: 3,
          url: '651229474',
          subject: 'Ciencias Naturales',
          pageNumber: 125,
          title: 'Cadena de elementos'
        },
        {
          grade: 6,
          trim: 3,
          url: '651229643',
          subject: 'Formación Cívica y Ética',
          pageNumber: 194,
          title: 'La carta de la tierra'
        },
        {
          grade: 6,
          trim: 3,
          url: '651229775',
          subject: 'Formación Cívica y Ética',
          pageNumber: 106,
          title: 'Ciudadanía y nacionalidad'
        },
        {
          grade: 6,
          trim: 3,
          url: '651229841',
          subject: 'Ciencias Naturales',
          pageNumber: 146,
          title: 'Datos interesantes de los planetas'
        },
        {
          grade: 6,
          trim: 3,
          url: '651229926',
          subject: 'Geografía',
          pageNumber: 193,
          title: 'Efectos del calentamiento global'
        },
        {
          grade: 6,
          trim: 3,
          url: '651230143',
          subject: 'Historia',
          pageNumber: 16,
          title: 'El castillo medieval'
        },
        {
          grade: 6,
          trim: 3,
          url: '651230361',
          subject: 'Historia',
          pageNumber: 82,
          title: 'El imperio bizantino'
        },
        {
          grade: 6,
          trim: 3,
          url: '651230458',
          subject: 'Historia',
          pageNumber: 16,
          title: 'Invasión de los pueblos bárbaros'
        },
        {
          grade: 6,
          trim: 3,
          url: '651230533',
          subject: 'Historia',
          pageNumber: 170,
          title: 'La caída de constantinopla'
        },
        {
          grade: 6,
          trim: 3,
          url: '651230706',
          subject: 'Geografía',
          pageNumber: 39,
          title: 'La producción de papel'
        },
        {
          grade: 6,
          trim: 3,
          url: '651230818',
          subject: 'Matemáticas',
          pageNumber: 155,
          title: 'Mínimo común múltiplo'
        },
        {
          grade: 6,
          trim: 3,
          url: '651230938',
          subject: 'Matemáticas',
          pageNumber: 27,
          title: 'Secuencia Fibonacci'
        },
        {
          grade: 6,
          trim: 3,
          url: '651231139',
          subject: 'Expresión escrita',
          pageNumber: 56,
          title: 'Textos de tradición oral mexicana'
        },
      ],
      audios: [
        {
          "title": "1-Adagio Albinoni ",
          "id": "587977473",
        },
        {
          "title": "2-Concierto 5 Bach ",
          "id": "587977449",
        },
        {
          "title": "3-Concierto 1 de Chopin ",
          "id": "587977423",
        },
        {
          "title": "4-Sonata 11 de Mozart (variacion en A) ",
          "id": "587977385",
        },
        {
          "title": "5-Sonata 11 (minuet) Mozart ",
          "id": "587977330",
        },
        {
          "title": "7-Menuet 1 Bach (Clavicordio) ",
          "id": "587977294",
        },
        {
          "title": "7-Menuet 1 Bach ",
          "id": "587977292",
        },
        {
          "title": "8-Menuet 2 Bach ",
          "id": "587977252",
        },
        {
          "title": "9-Aria bwv 988 Bach ",
          "id": "587977216",
        },
        {
          "title": "10-Barcarolle Tchaikovsky ",
          "id": "587977173",
        },
        {
          "title": "11-Concierto 1 Chopin 1er Mov ",
          "id": "587977084",
        },
        {
          "title": "12-Pequeña serenata Haydn ",
          "id": "587977135",
        },
        {
          "title": "13-Preludio Raindrop Chopin ",
          "id": "587977063",
        },
        {
          "title": "14-Sonata patética 2 Mov  Beethoven ",
          "id": "587977012",
        },
        {
          "title": "15-Traumerei Schumann ",
          "id": "587976994",
        },
        {
          "title": "16-Vals l'adieu Chopin ",
          "id": "587976944",
        },
        {
          "title": "17-Estudio 1 Scriabin ",
          "id": "587976938",
        },
        {
          "title": "18-Estudio 3 Chopin ",
          "id": "587977507",
        },
        {
          "title": "19-Soneto del petrarca Liszt ",
          "id": "587977546",
        },
      ],
      essentials: [],
    };
  },
  methods: {
    init() {
    try {
      const foundStudent = this.$store.state.session.currentUser.roles.find(
        element => element.role.code === "STUDENT"
      );
      if (foundStudent) {
        this.gradeData = this.$store.state.session.currentGrade.data;
        this.essentials = this.gradeData.essentials;
      }
    } catch (error) {
      console.error(error);
    }
  },
    changeTrim(trim) {
      this.trim = trim;
    },
    logout() {
      Auth.logout();
    },
    showCurse(asignatura) {
      this.isDownloadable = true;
      this.isVideo = false
      this.isAudio = false
      this.isAsignatura = asignatura;
    },
    downloadIframe(url) {
      window.open(url, '_blank');
    },
    showIframe(id) {
      this.isIframe = false;
      this.iframeId = id;
      console.log(this.iframeId)
    },
    showVideo() {
      this.isDownloadable = false;
      this.isVideo = true
      this.isAudio = false
    },
    showAudio() {
      this.isDownloadable = false;
      this.isVideo = false;
      this.isAudio = true;
    },

    goToEnglishVersion() {
      this.$router.push({ path: `/essential/mission/${this.missionId}/recursos` });
    }

  },
}
</script>
<style lang="scss">
.screen-container-book {
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  display: flex;
  background-size: 100% 100%;
  background-position: center center;
}

.background-activities {
  background-image: url('/img/bg-14.png');
  background-size: cover;
  width: 100%;
  min-height: 100vh;
  display: flex;
}

.sideBar {
  background: rgb(0, 0, 0);
  background: radial-gradient(circle, rgba(0, 0, 0, 0.8018557764902836) 0%, rgba(0, 0, 0, 0.8186624991793592) 35%, rgba(0, 0, 0, 0.7178221630449055) 80%);
  max-width: 500px;
  height: 100vh;
  max-height: 100vh;
  padding: 34px;
  margin: 0;
  font-family: Montserrat;
  font-weight: 800;
  color: #98D3FD;
  text-align: center;
  display: flex;
  flex-direction: column;

  h1 {
    font-family: 'Montserrat';
    font-weight: 900;
    border-bottom: 2px solid #98D3FD;
    border-left: 2px solid #98D3FD;
    margin-bottom: 0;
    padding: 15px 0px 15px 15px;
  }

  .list {
    display: flex;
    flex-direction: column;
    margin: 0 0 0 17px;

    .button-container {
      button {
        width: 100%;

        &:hover {
          background: #98d3fd;
          transition: all 0.4s ease-in;
          color: #fff;
          text-shadow: 1.5px 1px #070704a1;
        }
      }
    }
  }
}

#contenedor {
  color: 'red';

  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -23px;
    word-wrap: fit-content;
    background: url("/img/new/containerLogin.png");
    height: 30px;
  }
}

.imgUsa {
  width: 30px; // Ajusta el ancho como desees
  height: auto; // Mantén la relación de aspecto
  margin-bottom: 9px;
  margin-left: 10px;
}

.button-container {
  margin-left: -2px;
  display: flex;
  align-items: center;
  justify-content: center;

  // &:first-child {
  //   border-top: 2px solid #98D3FD;
  // }
  &:last-child {
    button {
      margin-bottom: 5px;
    }
  }

  button {
    background: transparent;
    width: fit-content;
    height: fit-content;
    font-family: Montserrat;
    font-weight: 800;
    color: #98D3FD;
    border: none;
    position: relative;
    height: 50px;
    margin-bottom: 30px;
    text-align: left;
    border-left: 2px solid #98D3FD;
    min-width: 74%;
    text-transform: uppercase;
  }

  button:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -23px;
    word-wrap: fit-content;
    background: url('/img/new/linea.png') repeat-x 100% 0;
    height: 30px;
  }
}

.container-actividades-buttons {
  overflow-y: auto;
  max-height: calc(100vh - 142px);
  margin-left: 30px;
  border-left: 2px solid;
  margin-top: -1px;
  border-top: 2px solid #020502;
}

.recursos {
  color: #fff;
  text-align: left;
  padding-left: 3.5rem;
}

.container-actividades-buttons::-webkit-scrollbar {
  width: 7px;
}

/* Track */
.container-actividades-buttons::-webkit-scrollbar-track {
  background: rgb(2, 24, 40);
}

/* Handle */
.container-actividades-buttons::-webkit-scrollbar-thumb {
  background: #98d3fd;
}

/* Handle on hover */
.container-actividades-buttons::-webkit-scrollbar-thumb:hover {
  background: #98d3fd;
}

.container-resources {
  justify-content: space-around;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;

  button {
    font-size: .8em;
    background: #040403c9;
    margin: 0 5px;
    text-shadow: 1.5px 1px #070704a1;
    border: 1px solid white;
    color: #fff;
    cursor: pointer;
    padding: 0px 16px;
  }

  button:hover {
    background: #98d3fd;
  }

  .active {
    background: #98d3fd;
  }
}

.container-audio {
  height: 100%;
  width: 100%;
  max-height: calc(100vh - 2px);
  overflow-y: auto;
  display: grid;
  grid-template-columns: calc(50% - 5px) calc(50% - 5px);
  grid-template-rows: auto;
  overflow-y: auto;
  border: 2px solid #98d3fd;
  background: #20455fab;
  column-gap: 10px;
  row-gap: 10px;
  padding: 10px;

  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-track {
    background: rgb(2, 24, 40);
  }

  &::-webkit-scrollbar-thumb {
    background: #98d3fd;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #98d3fd;
  }

  button {
    text-decoration: none;
    line-height: 1.6em;
    font-size: 2em;
    padding: 0.5em;
    display: block;
    color: white;
    font-family: 'Montserrat';
    font-weight: 900;
    transition: all 0.9s ease-in;
    border-right: 2px solid #98d3fd !important;
    border-bottom: 2px solid #98d3fd !important;
    border: 2px transparent;
    background: #20455fab;
    cursor: pointer;

    &:hover {
      background: #6b94b1;
      color: #fff;
      cursor: pointer;
      transition: 3;
      transition: all 0.5s ease-out;
    }
  }
}

.container-videos {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: inherit;
  max-height: calc(100vh - 20px);
  overflow-y: auto;
  height: 100%;
  top: 0;
  margin-top: 13px;

  .container-buttons {
    position: inherit;
    height: 100%;
    display: grid;
    grid-template-columns: calc(50% - 5px) calc(50% - 5px);
    grid-template-rows: auto;
    overflow-y: auto;
    border: 2px solid #98d3fd;
    background: #20455fab;
    column-gap: 10px;
    row-gap: 10px;
    padding: 10px;

    &::-webkit-scrollbar {
      width: 7px;
    }

    &::-webkit-scrollbar-track {
      background: rgb(2, 24, 40);
    }

    &::-webkit-scrollbar-thumb {
      background: #98d3fd;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #98d3fd;
    }

    button {
      text-decoration: none;
      line-height: 1.6em;
      font-size: 2em;
      padding: 0.5em;
      display: block;
      color: white;
      font-family: 'Montserrat';
      font-weight: 900;
      transition: all 0.9s ease-in;
      border-right: 2px solid #98d3fd !important;
      border-bottom: 2px solid #98d3fd !important;
      border: 2px transparent;
      background: #20455fab;

      &:hover {
        background: #6b94b1;
        color: #fff;
        cursor: selector;
        cursor: pointer;
        transition: 3;
        transition: all 0.5s ease-out;
      }
    }
  }

  .tab-trim {
    display: flex;
    padding: 9px;

    button {
      background: #040403c9;
      margin: 0 5px;
      text-shadow: 1.5px 1px #070704a1;
      border: 1px solid white;
    }

    button:hover {
      background: #98d3fd;
    }

    .active {
      background: #98d3fd;
    }
  }

  h2 {
    button {
      background-color: #98d3fd52;
      /* border: 2px solid #98d3fd; */
      border-radius: 4px;
      cursor: pointer;
    }
  }

  button {
    background-color: transparent;
    border: none;
    color: #fff;
    font-family: Montserrat;
    font-weight: 800;
    font-size: 21px;
    padding: 7px 16px;
    ;
    background-color: #98d3fd0a;
    padding: auto;
  }

  a {
    background-color: transparent;
    border: none;
    color: #fff;
    font-family: Montserrat;
    font-weight: 800;
    font-size: 21px;
    padding: 12px 0;
    background-color: #98d3fd0a;
  }

  a:hover {
    color: #fff;
    text-decoration: none;
    background-color: rgba(0, 0, 0, 0.801856);
  }
}
</style>